import React, { Fragment } from 'react'
import Social from './Home/Social'

const Footer = () => {
    return (
    <Fragment>
    <footer id="footer">
      <div>
        <Social />
      </div>
    </footer>
    </Fragment>
    )
}

export default Footer
